module.exports = __webpack_public_path__ + "static/img/logo.0913b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 116